webpackJsonp([51442151656975],{

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onzijdig"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "is"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ea"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "id"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eius"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eius"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eius"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ei"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ei"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ei"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eum"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "id"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "eo"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ea"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "eo"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ei"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eae"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ea"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eorum"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "earum"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eorum"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eis"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eis"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eis"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eos"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eas"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ea"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "eis"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "eis"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "eis"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            { colSpan: 3, className: "center" },
	            _react2.default.createElement(
	              "i",
	              null,
	              "1. deze, dit, die, dat \xA0\xA0\xA0 2. hij, zij, het"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "Dit rijtje lijkt erg op het rijtje van",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "bijvoeglijk-naamwoord" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "longus"
	          )
	        ),
	        ". Alleen de nominativus, genitivus en dativus enkelvoud wijken af."
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TableSelector = __webpack_require__(28);
	
	var _TableSelector2 = _interopRequireDefault(_TableSelector);
	
	var _verwVnw = __webpack_require__(671);
	
	var _verwVnw2 = _interopRequireDefault(_verwVnw);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var data = [{
	  les: "40",
	  table: _verwVnw2.default
	}];
	
	exports.default = function () {
	  return _react2.default.createElement(_TableSelector2.default, {
	    defaultChapter: "40",
	    data: data,
	    title: "Verwijzend voornaamwoord"
	  });
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-spqr-rijtjes-verwijzend-voornaamwoord-js-1e69546a5e8504165ef7.js